function getCouponDiscount (coupon, { price, guests, total }) {
  let amount = 0
  let off = 0
  let left = 0

  if (!coupon || !coupon.type) {
    return { amount: total, off, left }
  }

  if (coupon.type === 'discount') {
    const { discount } = coupon
    const offPercent = total * discount.percent / 100
    const offExpense = Math.min(total, discount.expense)

    if (!discount.expense) {
      off = offPercent
    } else if (!discount.percent) {
      off = offExpense
    } else {
      off = Math.min(offPercent, offExpense)
    }
    left = discount.expense > total ? discount.expense - total : 0
  } else if (coupon.type === 'guests') {
    const discountedGuests = Math.min(guests, coupon.guests)
    off = price * discountedGuests
  } else if (coupon.type === 'mixed') {
    const discountedGuests = Math.min(guests, coupon.guests)
    off = coupon.discount.expense * discountedGuests
  }

  amount = total - off

  return { amount, off, left }
}
exports.getCouponDiscount = getCouponDiscount
